import {
  AtlasBodySubtitle,
  AtlasCaption,
  BottomGroupMolecule,
  CardComponent,
  PageContentAtom,
  PrimaryButtonAtom,
  TextBoxMolecule,
  ToolbarMolecule
} from '@justomx/atlas-components'
import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { ImageMolecule } from 'components/molecule/Image.molecule'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ApprovalScreenOrganism } from 'components/organisms/ApprovalScreen.organism'
import { ModalOrganism } from 'components/organisms/Modal.organism'
import { useMissing } from './Missing.hook'

const MissingPage = () => {
  const { actions, product, quantity, showOTPModal, loading } = useMissing()

  if (!product) {
    return null
  }

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <ToolbarMolecule
        title="Reporte de faltante"
        actionIcon="close"
        onAction={actions.onGoBack}
      />

      {showOTPModal && (
        <ModalOrganism
          title="Ingresa código"
          actionIcon="ic_arrow_back"
          onAction={actions.closeOtpModal}
        >
          <ApprovalScreenOrganism onConfirmOTPCode={actions.onConfirmOTPCode} />
        </ModalOrganism>
      )}

      <PageContentAtom>
        <StackAtom $direction="column" $gap={24}>
          <CardComponent $variant="highlight" style={{ background: '#9A9A9A' }}>
            <StackAtom $direction="column" $gap={8}>
              <AtlasCaption>Producto seleccionado</AtlasCaption>

              <StackAtom $gap={12} $align="center">
                <ImageMolecule
                  src={product.imgUrl}
                  size={60}
                  alt="product-img"
                />

                <StackAtom $direction="column" $gap={12}>
                  <AtlasBodySubtitle>{product.name}</AtlasBodySubtitle>
                  <AtlasCaption>
                    UPC: {product.barcode} | SKU: {product.sku}
                  </AtlasCaption>
                  <AtlasCaption>
                    Cantidad: {product.quantity}{' '}
                    {product.measureUnit === 'kg'
                      ? 'gr'
                      : product.measureUnit === 'CAJA'
                        ? 'cajas'
                        : 'unidades'}
                  </AtlasCaption>
                </StackAtom>
              </StackAtom>
            </StackAtom>
          </CardComponent>

          <InstructionsMolecule
            lines={[
              'Escribe la cantidad faltante.',
              'Después, selecciona Registrar.'
            ]}
          />

          <TextBoxMolecule
            label="Cantidad"
            value={quantity}
            onChangeFullEvent={actions.onChangeQuantity}
          />
        </StackAtom>

        <BottomGroupMolecule bgColor="#212121">
          <PrimaryButtonAtom
            type="button"
            disabled={!quantity}
            onClick={actions.confirmQuantity}
          >
            Registrar
          </PrimaryButtonAtom>
        </BottomGroupMolecule>
      </PageContentAtom>
    </>
  )
}

export default MissingPage
